export const TEAM_ITEM_INITIALIZE = 'PAGE_TEAM_ITEM_INITIALIZE';
export const TEAM_ITEM_SAML_CONFIG_INPUT_CHANGE = 'PAGE_TEAM_ITEM_FIELD_UPDATE';

export function initialize() {
  return {
    type: TEAM_ITEM_INITIALIZE
  };
}

export function samlConfigInputChange(field, newData) {
  return {
    type: TEAM_ITEM_SAML_CONFIG_INPUT_CHANGE,
    field,
    newData
  };
}



// WEBPACK FOOTER //
// ./js/actions/page/Team.js